import GiftCardsContainer from './components/Container';
import { usePageViewEvent, useFiltersChangeEvent } from 'shared/gtm/hooks';

function GiftCards() {
  usePageViewEvent();
  useFiltersChangeEvent();

  return <GiftCardsContainer />;
}

export default GiftCards;
